/* eslint-disable jira/filename-case */

import React, { type ReactNode } from 'react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { AssetsLayout as AssetsLayoutType } from './AssetsLayout.tsx';

export const LazyAssetsLayout: LazyComponent<
	({ children }: { children: ReactNode }) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof AssetsLayoutType>(
		() =>
			import(/* webpackChunkName: "async-assets-layout" */ './AssetsLayout.tsx').then(
				(module) => module.AssetsLayout,
			),
		{ ssr: false },
	);

export const AssetsLayout = ({ children }: { children: ReactNode }): React.JSX.Element => (
	<Placeholder name="assets-layout-async" fallback={<UFOLoadHold name="assets-layout-async" />}>
		<LazyAssetsLayout>{children}</LazyAssetsLayout>
	</Placeholder>
);
